import { ref, watch } from 'vue';
import useProductDetailData from '@/shared/product/details/useProductDetailData';
import { ProductSpecificationTileModel } from '@/types/StoreContextContentServerContract';

const selectedTabIndex = ref<number>(0);
const transparencyReadMoreLinks = ref<Partial<Pick<ProductSpecificationTileModel, 'readMoreAboutCertificatesLink' | 'readMoreAboutClimateFootprintLink' | 'readMoreAboutTestsLink'>>>({});

export default function useProductSpecificationsTile() {
    const { productId } = useProductDetailData();
    const setSelectedTabIndex = (idx: number) => {
        selectedTabIndex.value = idx;
    };

    const setTransparencyReadMoreLinks = (content: ProductSpecificationTileModel) => {
        transparencyReadMoreLinks.value.readMoreAboutCertificatesLink = content.readMoreAboutCertificatesLink;
        transparencyReadMoreLinks.value.readMoreAboutClimateFootprintLink = content.readMoreAboutClimateFootprintLink;
        transparencyReadMoreLinks.value.readMoreAboutTestsLink = content.readMoreAboutTestsLink;
    };

    watch(productId, () => selectedTabIndex.value = 0);

    return {
        selectedTabIndex,
        setSelectedTabIndex,
        transparencyReadMoreLinks,
        setTransparencyReadMoreLinks,
    };
}
